import React, { useState, useEffect } from "react";
import TextField from '@material-ui/core/TextField'

import RenderError from '../render-error'
import CountryList from '../country-list'

import countryList from '../../data/countrylist'

interface BillingAddressProps {
  [key: string]: any
}

const BillingAddress: React.FC<BillingAddressProps> = (props:any) => {

  // const donation = useContext(DonationContext)

  const [ showAddress, setShowAddress ] = useState(false)
  const [ addressReturned, setAddressReturned ] = useState(false)
  const [ country, setCountry ] = useState('')

  function countryName(countryCode :any) {
    for (let i = 0; i < countryList.length; i++) {
      if (countryList[i].code === countryCode) {
        setCountry(countryList[i].name)
      }
    }
  }

  useEffect(() => {
      let pca = (window as any).pca || {}
      let fields = [
        { element: "address_search", field: "", mode: pca.fieldMode.SEARCH },
        { element: "address_1", field: "Line1", mode: pca.fieldMode.POPULATE },
        { element: "address_2", field: "Line2", mode: pca.fieldMode.POPULATE },
        { element: "address_3", field: "Line3", mode: pca.fieldMode.POPULATE },
        { element: "town_city", field: "City", mode: pca.fieldMode.POPULATE },
        { element: "county_state", field: "Province", mode: pca.fieldMode.POPULATE },
        { element: "postcode", field: "PostalCode", mode: pca.fieldMode.POPULATE },
        { element: "country", field: "CountryName", mode: pca.fieldMode.COUNTRY }
      ]

      let options = { key: 'MR59-RU97-KF54-MD65' }
      let control = new pca.Address(fields, options);

      (document as any).getElementById('address_search').autocomplete = 'new-password'

      control.listen("populate", function (address :any) {
        setAddressReturned(true);
        setShowAddress(false);
        props.setFieldValue('address_search', '')
        props.setFieldValue('address_1', address.Line1)
        props.setFieldValue('address_2', address.Line2)
        props.setFieldValue('address_3', address.Line3)
        props.setFieldValue('town_city', address.City)
        props.setFieldValue('county_state', address.Province)
        props.setFieldValue('postcode', address.PostalCode)
        props.setFieldValue('country', address.CountryIso2)
        countryName(address.CountryIso2)
      })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
      if (props.values.address_1 && props.values.country) {
        countryName(props.values.country)
        setAddressReturned(true)
      }
  }, [props.values.address_1, props.values.country])

  useEffect(() => {
      if (props.errors.address_1 || props.errors.postcode || props.errors.town_city) {
        if (props.submitCount > 0) {
          setShowAddress(true)
        }
      }
  }, [props.errors.address_1, props.errors.postcode, props.errors.town_city, props.submitCount])

  return (
    <>
      <div className="row">
        <div className="billing-address clearfix box">
          <div className="medium-6 columns">
            <h2>Your billing address</h2>
            <fieldset>
              <legend>Your billing address</legend>
              <div className="input-container md-block" id="address-search-field">
                <TextField
                  type="text"
                  variant="outlined"
                  id="address_search"
                  name="address_search"
                  label="Start typing an address"
                  inputProps={{
                    "aria-describedby": "address_search_error"
                  }}
                  error={props.errors.address_search ? true : false}
                  value={props.values.address_search}
                  onChange={props.handleChange} />
                <RenderError name="address_search" id="address_search_error" {...props} />
                <button type="button" id="address-manual" tabIndex={0} className="link" onClick={() => setShowAddress(!showAddress)} aria-expanded={showAddress} aria-controls="address-fields">Enter your address manually</button>
              </div>
              <div className={`address-hidden-fields ${showAddress ? '' : 'hidden'}`} id="address-fields" aria-live="polite">
                <div className="input-container">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="org_name"
                    name="organisation"
                    label="Organisation (optional)"
                    autoComplete="organization"
                    inputProps={{
                      "aria-describedby": "org_name_error"
                    }}
                    error={props.errors.organization ? true : false}
                    value={props.values.organization}
                    onChange={props.handleChange} />
                  <RenderError name="organisation" id="org_name_error" {...props} />
                </div>
                <div className="input-container">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="address-1"
                    name="address_1"
                    label="Address 1"
                    autoComplete="address-line1"
                    inputProps={{
                      "aria-describedby": "address-1_error"
                    }}
                    error={props.errors.address_1 ? true : false}
                    value={props.values.address_1}
                    onChange={props.handleChange} />
                  <RenderError name="address_1" id="address-1_error" {...props} />
                </div>
                <div className="input-container">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="address-2"
                    name="address_2"
                    label="Address 2 (optional)"
                    autoComplete="address-line2"
                    inputProps={{
                      "aria-describedby": "address-2_error"
                    }}
                    error={props.errors.address_2 ? true : false}
                    value={props.values.address_2}
                    onChange={props.handleChange} />
                  <RenderError name="address_2" id="address-2_error" {...props} />
                </div>
                <div className="input-container">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="address-3"
                    name="address_3"
                    label="Address 3 (optional)"
                    autoComplete="address-line3"
                    inputProps={{
                      "aria-describedby": "address-3_error"
                    }}
                    error={props.errors.address_3 ? true : false}
                    value={props.values.address_3}
                    onChange={props.handleChange} />
                  <RenderError name="address_3" id="address-3_error" {...props} />
                </div>
                <div className="input-container">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="town-city"
                    name="town_city"
                    label="Town/city"
                    autoComplete="address-level2"
                    inputProps={{
                      "aria-describedby": "town-city_error"
                    }}
                    error={props.errors.town_city ? true : false}
                    value={props.values.town_city}
                    onChange={props.handleChange} />
                  <RenderError name="town_city" id="town-city_error" {...props} />
                </div>
                <div className="input-container">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="county-state"
                    name="county_state"
                    label="County/state (optional)"
                    autoComplete="address-level1"
                    inputProps={{
                      "aria-describedby": "county-state_error"
                    }}
                    error={props.errors.county_state ? true : false}
                    value={props.values.county_state}
                    onChange={props.handleChange} />
                  <RenderError name="county_state" id="county-state_error" {...props} />
                </div>
                <div className="input-container">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="postcode"
                    name="postcode"
                    label="Postcode"
                    autoComplete="postal-code"
                    inputProps={{
                      "aria-describedby": "postcode_error"
                    }}
                    error={props.errors.postcode ? true : false}
                    value={props.values.postcode}
                    onChange={props.handleChange} />
                  <RenderError name="postcode" id="postcode_error" {...props} />
                </div>
                <CountryList {...props} />
              </div>
            </fieldset>
          </div>
          <div className="medium-6 columns">
            <div className="form-item">
              { addressReturned &&
                <div className="address-label">
                  <div>
                    <span>{props.values.organisation}</span>
                    <span>{props.values.address_1}</span>
                    <span>{props.values.address_2}</span>
                    <span>{props.values.address_3}</span>
                    <span>{props.values.town_city}</span>
                    <span>{props.values.county_state}</span>
                    <span>{props.values.postcode}</span>
                    <span>{country}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingAddress;